'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
exports.default = function (dimensions, singularity) {
  var value = dimensions.value,
    values = dimensions.values;
  var mode = R.prop('mode', singularity) === 'percent' ? 'percent' : 'values';
  if (R.length(values) === 1) {
    return {
      limit: R.propOr(Infinity, 'limit', singularity),
      mode: mode,
      id: R.pathOr(null, [0, 'id'], value)
    };
  }
  var serieDimension = null;
  var id = R.prop('id', singularity);
  if (!R.isNil(id)) {
    serieDimension = R.find(R.propEq('id', id), values);
  }
  var areaDimension = (0, _dotstatsuiteSdmxjs.getRefAreaDimension)({
    dimensions: values
  });
  var timeDimension = (0, _dotstatsuiteSdmxjs.getTimePeriodDimension)({
    dimensions: values
  });
  serieDimension = serieDimension || areaDimension || timeDimension || R.head(values);
  return {
    limit: R.propOr(Infinity, 'limit', singularity),
    mode: mode,
    id: R.propOr(null, 'id', serieDimension)
  };
};